import { render } from "./ModalWindow.vue?vue&type=template&id=38752049"
import script from "./ModalWindow.vue?vue&type=script&lang=js"
export * from "./ModalWindow.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Askar\\personalArea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__